/** @jsx jsx */
/** @jsxRuntime classic */
import { jsx } from 'theme-ui'

const IframeContainer = () => {
  return <div data-iframe-height="1" />
}

export default IframeContainer
